import { object, string } from 'yup'

export const accountRenewalSchema = object({
    renewalType: string()
            .oneOf(['auto', 'manual'], 'There is no such type'),
    renewalCycle: string()
            .oneOf(['monthly', 'annual'], 'There is no such type'),
})